import { hysteriFetch, wrappers } from 'hysterics';

export default async function fetchNLSResults(
	widgetSearchServiceUri,
	siteId,
	locale,
	device,
	pageAlias,
	windowId,
	widgetName,
	listingConfigId,
	searchTerm
) {
	const nlsClientService = hysteriFetch('nlsClientService', {
		[wrappers.circuitBreaker.contextKey]: {
			timeout: 10000
		},
		[wrappers.timeout.contextKey]: {
			timeout: 10000
		},
		[wrappers.retry.contextKey]: {
			retries: 0
		}
	});
	const requestBody = {
		siteId,
		locale,
		device,
		pageAlias,
		windowId,
		widgetName,
		listingConfigId,
		facetInstanceId: 'listing',
		shouldReturnCardsAlso: true,
		query: searchTerm
	};
	return nlsClientService(
		`${widgetSearchServiceUri}/nlInventorySearch/${siteId}/${locale}?q=${encodeURIComponent(
			searchTerm
		)}`,
		{
			method: 'POST',
			body: JSON.stringify(requestBody)
		}
	);
}
